<template>
  <div style="max-width: 500px; margin: 0 auto">
    <Fontnavbar title="动态" />
    <div class="cont_type">
      <div class="title">选择类型：</div>
      <ul>
        <li :class="{on:curr == 0}" @click="curr = 0">全部</li>
        <li :class="{on:curr == 1}" @click="curr = 1">个秀</li>
        <li :class="{on:curr == 2}" @click="curr = 2">分销</li>
      </ul>
    </div>
    <van-field v-model="geshow" label="个秀" placeholder="请输入内容" v-if="curr!=2"/>
    <van-field v-model="message" rows="2" autosize label="内容" type="textarea" maxlength="300" placeholder="请输入动态内容" show-word-limit />

    <div class="cont_type">
      <div class="title">上传类型：</div>
      <ul>
        <li :class="{on:currtype == 1}" @click="uploadType(1)">图片</li>
        <li :class="{on:currtype == 2}" @click="uploadType(2)">视频</li>
      </ul>
    </div>
    <div class="d-upload" v-if="currtype==1">
      <van-uploader :after-read="afterRead" :before-delete="deleteImg" v-model="fileList" multiple :max-count="9" closeable />
    </div>
    <div class="d-upload" v-if="currtype==2">
      <van-uploader :accept="acceptType" :max-size="10* 1024 * 1024" @oversize="onOversize" :after-read="afterRead" :before-delete="deleteImg" v-model="fileList" :max-count="1" closeable />
    </div>

    <div class="d-goods">
      <div class="d-goods-text">关联商品</div>

      <div class="goods" v-for="(item, i) in selectGoods" :key="i" style="display: flex; background: #ffffff">
        <div class="goods_img" style="height: 100%; width: 50%">
          <img :src="imgDomain + item.goods_thumb_path" alt="" class="img" style="width: 100%; height: 100%; background: #ffffff" />
        </div>
        <div class="van-cell-group van-hairline--top-bottom van-panel">
          <div class="van-cell van-panel__header">
            <div class="van-cell__title">
              <span>{{ item.goods_name }}</span>
              <div class="van-cell__label" v-text="item.is_sale ? '' : '[已下架]'"></div>
            </div>
            <div class="van-cell__value van-panel__header-value">
              <span @click="checkDeleteGoods(i)">删除</span>
            </div>
          </div>
          <div class="van-panel__content"></div>
        </div>
      </div>
    </div>
    <van-search v-model="goodsValue" show-action placeholder="请输入商品名称/货号" @search="onSearch">
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <div v-if="isShow">
      <div class="goods" v-for="(item, i) in goods" :key="i" style="display: flex; background: #ffffff">
        <div class="goods_img" style="height: 100%; width: 50%">
          <img :src="imgDomain + item.goods_thumb_path" alt="" class="img" style="width: 100%; height: 100%; background: #ffffff" />
        </div>
        <van-panel :title="item.goods_name" :desc="item.is_sale ? '' : '[已下架]'" status="已选择" v-if="item.isSelect" />
        <van-panel :title="item.goods_name" :desc="item.is_sale ? '' : '[已下架]'" status="选择" @click="checkGoods(item.id, i)" v-else />
      </div>
    </div>

    <div class="login-btn">
      <van-button round block type="danger" @click="doDynamic" v-if="dynamicId == 0">
        立即发布
      </van-button>
      <van-button round block type="danger" @click="doDynamic" v-else>
        确认修改
      </van-button>
    </div>
  </div>
</template>

<script>
import {
  uploadDyFile,
  getGoodsList,
  getDynamicDetail,
  updateDynamic,
} from "../../../api.js";
import { post, postForm } from "../../../request.js";
import { compressImage } from "../../../utils/compressImage";
import { Button, Field, Toast, Uploader, Search, Panel } from "vant";
import Fontnavbar from "../../../components/Navbar.vue";
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [Search.name]: Search,
    [Panel.name]: Panel,
    Fontnavbar,
  },
  data () {
    return {
      imgDomain: process.env.VUE_APP_IMG_URL,
      dynamicId: 0,
      message: "",
      goodsValue: "",
      fileList: [],
      goods: [],
      gallaryArr: [],
      isGoods: false,
      isShow: false,
      selectGoods: [],
      geshow: '',
      curr: 1,
      currtype: 1,
      acceptType: 'video/mp4',
      video: ''
      //   goodsId: 0,
    };
  },

  created () {
    const that = this;
    if (that.$route.query.dynamic_id) {
      that.dynamicId = that.$route.query.dynamic_id;
      post(getDynamicDetail, { dynamic_id: that.dynamicId }).then((res) => {
        if (res.code == 200) {
          that.message = res.data.content;
          that.geshow = res.data.geshow;
          if(res.data.video && res.data.video.length > 5) {
            this.currtype = 2
              that.fileList.push({ url: that.imgDomain + res.data.video });
          }

          this.curr = res.data.show_platform

          //   that.goodsId = res.data.goods_id ? res.data.goods_id : 0;
          that.gallaryArr = res.data.gallary_array;
          console.log(res);
          if (res.data.goods_id !== 0) {
            that.selectGoods = res.data.goods_list;
            that.isGoods = true;
          }
          if (that.gallaryArr.length > 0) {
            for (var i = 0; i < that.gallaryArr.length; i++) {
              that.fileList.push({ url: that.imgDomain + that.gallaryArr[i] });
            }
            window.console.log(that.fileList);
          }
        } else if (res.code == 201) {
          this.$router.push({ path: "/dynamic/admin/login" });
        }
      });
    }
  },

  methods: {
    uploadType(index){
      this.fileList = []
      this.currtype = index
    },
    //读取完图片后
    afterRead (file) {
      console.log("file", file);

      // if (Array.isArray(file)) {
      //   file.forEach((item) => {
      //     item.status = "uploading";
      //     this._compressAndUploadFile(item, file.length, 0);
      //   });
      // } else {
      //   file.status = "uploading";
      //   this._compressAndUploadFile(file);
      // }
      file.status = "uploading";
      this._uploadFile(0, file);
    },
    // 尺寸超出
    onOversize(){
        Toast('文件大小不能超过10M');
    },
    //压缩图片上传
    // _compressAndUploadFile(file) {
    //   console.log("file.file.size: ", file.file.size);

    //   if (file.file.size < 2 * 1024 * 1024) {
    //     this._uploadFile(file, file.file, file.file.name);
    //   } else {
    //     compressImage(file.content).then((result) => {
    //       console.log("result.size: ", result.size);

    //       if (result.size > file.file.size) {
    //         //压缩后比原来更大，则将原图上传
    //         this._uploadFile(file, file.file, file.file.name);
    //       } else {
    //         //压缩后比原来小，上传压缩后的
    //         this._uploadFile(file, result, file.file.name);
    //       }
    //     });
    //   }
    // },
    //上传图片
    _uploadFile (index = 0, file) {
      var that = this;
      let params = new FormData();
      // console.log(params);
      let resultFile = "";
      if (Array.isArray(file)) {
        // params.append('file', file[index].file)
        resultFile = file[index];
      } else {
        resultFile = file;
      }
      console.log('返回值3', resultFile)
      if (resultFile.file.size > 2 * 1024 * 1024 && resultFile.file.type != 'video/mp4' && resultFile.file.type != 'video/m4v') {
        // console.log('压缩2')
        compressImage(resultFile.content).then((result) => {
          if (result.size < resultFile.file.size) {
            params.append("file", result, resultFile.file.name);
          } else {
            params.append("file", resultFile.file, resultFile.file.name);
          }
          postForm(uploadDyFile, params).then((res) => {
            if (res.code == 200) {
              // console.log('多张图下标1', index)
              // ofile.status = "";
              
              if(that.currtype == 1){
                that.gallaryArr.push(res.data);
              }else{
                that.video = res.data
              }
              console.log('res: ', res);
              console.log('that.gallaryArr: ', that.gallaryArr);
              console.log('that.video: ', that.video);

              if (file.length) {
                file[index].status = "";
                if (++index < file.length) {
                  // console.log('多张图下标2', index)
                  this._uploadFile(index, file);
                }
              } else {
                file.status = "";
              }
            } else {
              Toast("网络错误");
            }
          });
        });
      } else {
        params.append("file", resultFile.file, resultFile.file.name);
        postForm(uploadDyFile, params).then((res) => {
          if (res.code == 200) {
            // console.log('多张图下标1', index)
            // ofile.status = "";
            // that.gallaryArr.push(res.data);
            if(this.currtype == 1){
                this.gallaryArr.push(res.data);
              }else{
                this.video = res.data
              }
              console.log('res: ', res);
              console.log('that.gallaryArr: ', that.gallaryArr);
              console.log('that.video: ', that.video);
            if (file.length) {
              file[index].status = "";
              if (++index < file.length) {
                // console.log('多张图下标2', index)
                this._uploadFile(index, file);
              }
            } else {
              file.status = "";
            }
          } else {
            Toast("网络错误");
          }
        });
      }
      // console.log(params);
    },

    onSearch () {
      this.getGoodsList();
    },

    // 获取商品列表
    getGoodsList () {
      var that = this;
      var loading = Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      var postData = {
        keywords: this.goodsValue,
        is_all: 1,
      };
      post(getGoodsList, postData).then((res) => {
        loading.clear();
        if (res.code == 200) {
          res.data.forEach((item) => {
            if (this.selectGoods.length > 0) {
              this.selectGoods.forEach((ele) => {
                if (ele.id == item.id) {
                  item.isSelect = true;
                } else {
                  item.isSelect = false;
                }
              });
            } else {
              item.isSelect = false;
            }
          });
          console.log(res.data);
          that.goods = res.data;
          this.isShow = true;
        } else {
          Toast("网络错误");
        }
      });
    },

    checkGoods (id, index) {
      if (this.selectGoods.length >= 9) {
        Toast("最多选择9个商品");
      } else {
        this.selectGoods.push(this.goods[index]);
        this.goods.forEach((ele) => {
          if (ele.id == id) {
            ele.isSelect = true;
          }
        });
        //   this.goodsId += "," + this.goods[index].id;
        // this.isShow = false;
        console.log(this.selectGoods, this.goods);
        this.isGoods = true;
      }
    },

    checkDeleteGoods (index) {
      this.goods.forEach((ele) => {
        if (ele.id == this.selectGoods[index].id) {
          ele.isSelect = false;
        }
      });
      this.selectGoods.splice(index, 1);
    },

    doDynamic () {
      if (this.message == "") {
        Toast("动态内容不能为空");
        return false;
      }
      var postData = {
        dynamic_id: this.dynamicId,
        content: this.message,
        gallary: this.gallaryArr.length > 0 ? this.gallaryArr.join(",") : '',
        goods_id: this.selectGoods,
        geshow: this.geshow,
        show_platform: this.curr,
      };
      if (this.video) {
          postData.video = this.video
      }
      var that = this;
      post(updateDynamic, postData).then((res) => {
        if (res.code == 200) {
          Toast.success(res.msg);
          setTimeout(function () {
            that.$router.back();
            // that.$router.replace({ path: "/dynamic/admin/index" });
          }, 1500);
        } else {
          Toast(res.msg);
        }
      });
    },

    goPage (path) {
      this.$router.push({ path: path });
    },

    deleteImg (e) {
      console.log(this.fileList, e);
      console.log(1)
      // console.log(e.src)
      if (this.$route.query.dynamic_id) {
        for (var i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].url == e.url) {
            this.gallaryArr.splice(i, 1);
            console.log(2)
          }
        }
        return true;
      } else {
        for (let j = 0; j < this.fileList.length; j++) {
          if (this.fileList[j].file.name === e.file.name) {
            this.gallaryArr.splice(j, 1);
          }
        }
        return true;
      }

    },
  },
};
</script>

<style lang="less" scoped>
.cont_type {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 15px;
  font-size: 14px;
  color: #646566;
  ul {
    display: flex;
    align-items: center;
    li{
      margin-left: 16px;
      width: 50px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      border-radius: 8px;
    }
    li.on{
      background-color: #1989fa;
      color: #ffffff;
    }
  }
}
.login-btn {
  margin: 15px;
}
.login-tip {
  margin: 15px 15px 0;
  font-size: 14px;
  color: #f00;
  text-align: right;
}
.login-tip span {
  margin: 0px 5px;
}
.van-uploader__preview-delete {
  top: 0px;
  right: 0px;
}
.d-upload {
  padding: 15px;
  background-color: #ffffff;
}
.d-goods {
  padding: 0 15px;
  background-color: #ffffff;
}
.d-goods-text {
  font-size: 14px;
  color: #333333;
}
.d-upload-text {
  font-size: 14px;
  color: #333333;
  padding-bottom: 10px;
}
.d-goods-name {
  line-height: 24px;
  color: #666666;
  font-size: 14px;
}
.d-goods-img {
  width: 100px;
  height: 100px;
}

.d-goods-img .img {
  height: 100%;
  width: 100%;
}
.goods .van-cell__label {
  color: red;
  font-weight: bolder;
}
</style>
